// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"854":"563674ba","959":"7ed86013","997":"82c73d26"}[chunkId] + ".css";
};